import React, { useEffect } from 'react'
import digital2025 from '../../assets/digital2025.png'
import QRCode from 'react-qr-code'
import domtoimage from 'dom-to-image';
import { useGlobalCarteira } from '../../storage/globalCarteira';
import { escolaridadeAll } from '../../utils';

export default function GlobalPdf2025({ show = false, data = null }) {

    const { dataCarteira } = useGlobalCarteira(state => state)

    var currentData = {
        cpf: dataCarteira?.cpf,
        imagem: dataCarteira?.imagem,
        codigoUso: dataCarteira?.codigoUso,
        nome: dataCarteira?.nome,
        email: dataCarteira?.email,
        rg: dataCarteira?.rg,
        dataNascimento: dataCarteira?.dataNascimento,
        instituicao: dataCarteira?.instituicao,
        curso: dataCarteira?.curso,
        escolaridade: dataCarteira?.escolaridade,
        codId: dataCarteira?.codId,
        validadeCarteirinha: dataCarteira?.validadeCarteirinha
    }

    if (data != null) {
        currentData = {
            cpf: data?.cpf,
            imagem: data?.imagem,
            codigoUso: data?.codigoUso,
            nome: data?.nome,
            email: data?.email,
            rg: data?.rg,
            dataNascimento: data?.dataNascimento,
            instituicao: data?.instituicao,
            curso: data?.curso,
            escolaridade: data?.escolaridade,
            codId: data?.codId,
            validadeCarteirinha: data?.validadeCarteirinha,
        }
    }

    const confDigital = {
        qrcodeTamanho: 85,
        qrcodeTop: '95px',
        qrcodeRight: '23px',
        fontSizeConteudo: '10px'
    }

    var size = '10px'

   


    function formatarCPF(valor) {
        try {
            const somenteNumeros = valor.replace(/\D/g, '');

            // Se não tiver exatamente 11 dígitos, retorna o valor original
            if (somenteNumeros.length !== 11) {
                return valor;
            }

            return somenteNumeros.replace(
                /(\d{3})(\d{3})(\d{3})(\d{2})/,
                '$1.$2.$3-$4'
            );
        } catch (error) {
            // Em caso de erro, retorna o valor original
            return valor;
        }
    }

    const oculto = show ? { display: 'flex', justifyContent: 'center', alignItems: 'center', margin: '20px 0' } : { width: '10px', height: '10px', overflow: 'auto', position: 'absolute', top: '0', left: '0' }

    return (
        <div  style={oculto}>
            <div id='node_to_pdf2025' style={{ width: '350px', height: '658px', position: 'relative' }}>
                <img width={350} height={658} src={digital2025} />
                <div style={{ position: 'absolute', top: '129px', right: '25px' }}>
                    {<QRCode
                        bgColor='#00000000'
                        size={135}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={`https://funemg.vercel.app/validar/${currentData?.email}`}
                        viewBox={`0 0 256 256`}
                    />}
                </div>
                {currentData?.imagem !== 0 && <img style={{ position: 'absolute', top: '122px', left: '20px', fontSize: '10px', width: '144px', height: '175px', borderRadius: '15px' }} src={currentData?.imagem} />}
                <h6 style={{ position: 'absolute', top: '272px', right: '17px', fontSize: '16px', width: '150px', textAlign: 'center', fontWeight:' 400' }}><b style={{ color: 'black' }}>{currentData?.codigoUso}</b> </h6>
                <div style={{ position: 'absolute', top: '323px', left: '25px', width: '300px', height: '180px', display: 'flex', justifyContent: 'space-around', flexDirection: 'column' }}>
                    <h6 style={{ fontSize: '14px', textAlign: 'start', minHeight: '10px', fontWeight:' 400' }}><b style={{ color: 'black' }}> {currentData?.nome?.toUpperCase()}</b></h6>
                    <h6 style={{ fontSize: '14px', textAlign: 'start', minHeight: '10px', fontWeight:' 400' }}><b style={{ color: 'black' }}>Ins. Ensino: {currentData?.instituicao?.toUpperCase()}</b></h6>
                    <h6 style={{ fontSize: '14px', textAlign: 'start', minHeight: '10px', fontWeight:' 400' }}><b style={{ color: 'black' }}>Curso: {currentData?.curso?.toUpperCase()}</b></h6>
                    <h6 style={{ fontSize: '14px', textAlign: 'start', minHeight: '10px', fontWeight:' 400' }}><b style={{ color: 'black' }}>Nível de Ensino: {currentData?.escolaridade?.toUpperCase()}</b></h6>
                    <h6 style={{ fontSize: '14px', textAlign: 'start', minHeight: '10px', fontWeight:' 400' }}><b style={{ color: 'black' }}>CPF: {formatarCPF(currentData?.cpf?.toUpperCase())}</b></h6>
                    <h6 style={{ fontSize: '14px', textAlign: 'start', minHeight: '10px', fontWeight:' 400' }}><b style={{ color: 'black' }}>RG: {currentData?.rg?.toUpperCase()}</b></h6>
                    <h6 style={{ fontSize: '14px', textAlign: 'start', minHeight: '10px', fontWeight:' 400' }}><b style={{ color: 'black' }}>Data de nasc: {currentData?.dataNascimento}</b> </h6>
                    <h6 style={{ fontSize: '14px', textAlign: 'start', minHeight: '10px', fontWeight:' 400' }}><b style={{ color: 'black' }}>Validade: {currentData?.validadeCarteirinha}</b></h6>
                </div>
                <a style={{ position: 'absolute', bottom: '62px', left: '122px', fontSize: '10px', height: '35px', width: '107px', }} href={`https://funemg.vercel.app/certificado/${currentData?.email}`}></a>
            </div>
        </div>
    )
}
